import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Grid,
  Chip,
  Avatar,
  Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

const medalColors = ['#FFD700', '#C0C0C0', '#CD7F32'];

const FaturamentoRankingModal = ({ open, onClose, rankingData = [] }) => {
  // Ordenar contratos por Faturamento (maior para menor)
  const sorted = [...rankingData]
    .filter(c => typeof c.indicadores?.['Faturamento'] === 'number')
    .sort((a, b) => b.indicadores['Faturamento'] - a.indicadores['Faturamento']);
  const top5 = sorted.slice(0, 5);
  const bottom5 = sorted.slice(-5).reverse();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 4, p: 2 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EmojiEventsIcon color="warning" />
          <Typography variant="h6" fontWeight={700}>Ranking de Faturamento</Typography>
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 0 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1, color: 'success.main' }}>5 Melhores</Typography>
            {top5.length === 0 && <Typography color="text.secondary">Sem dados</Typography>}
            {top5.map((item, idx) => (
              <Box key={item.num_contrato} sx={{ display: 'flex', alignItems: 'center', mb: 1.5, p: 1, borderRadius: 2, bgcolor: idx === 0 ? 'success.lighter' : 'background.paper', boxShadow: idx === 0 ? 2 : 0 }}>
                <Avatar sx={{ bgcolor: medalColors[idx] || 'success.main', mr: 2, width: 36, height: 36, fontWeight: 700 }}>
                  {idx < 3 ? <EmojiEventsIcon /> : idx + 1}
                </Avatar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography fontWeight={600}>{item.num_contrato}</Typography>
                  <Typography variant="body2" color="text.secondary">Faturamento: <b>{item.indicadores['Faturamento']}%</b></Typography>
                </Box>
                <Chip label={`#${idx + 1}`} color="success" size="small" />
              </Box>
            ))}
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1, color: 'error.main' }}>5 Piores</Typography>
            {bottom5.length === 0 && <Typography color="text.secondary">Sem dados</Typography>}
            {bottom5.map((item, idx) => (
              <Box key={item.num_contrato} sx={{ display: 'flex', alignItems: 'center', mb: 1.5, p: 1, borderRadius: 2, bgcolor: idx === 0 ? 'error.lighter' : 'background.paper', boxShadow: idx === 0 ? 2 : 0 }}>
                <Avatar sx={{ bgcolor: idx === 0 ? 'error.main' : 'grey.400', mr: 2, width: 36, height: 36, fontWeight: 700 }}>
                  <SentimentVeryDissatisfiedIcon />
                </Avatar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography fontWeight={600}>{item.num_contrato}</Typography>
                  <Typography variant="body2" color="text.secondary">Faturamento: <b>{item.indicadores['Faturamento']}%</b></Typography>
                </Box>
                <Chip label={`#${sorted.length - idx}`} color="error" size="small" />
              </Box>
            ))}
          </Grid>
        </Grid>
        <Divider sx={{ mt: 3 }} />
        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Os valores são baseados no ranking global de Faturamento (%) entre todos os contratos.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};


export default FaturamentoRankingModal; 